<template>
  <!-- 屏幕尺寸为电脑时显示 -->
  <div class="container" v-if="windowWidth >= 800">
    <div class="main">
      <!-- logo -->
      <a href="./index.html">
        <img class="logo" src="../../assets//images/homeView/LOGO.png" alt="">
      </a>
      <!-- 下拉菜单列表 -->
      <div class="menuCon">
        <a href="./index.html">
          <div class="menuList" :class="menuType == 1 ? 'menuListAct' : ''">
            <p>{{ copyData.homeView.menuList.index }}</p>
          </div>
        </a>
        <div class="menuList" :class="menuType == 2 ? 'menuListAct' : ''" @mouseenter="mouseOver(1)"
             @mouseleave="mouseLeave()">
          <p>{{ copyData.homeView.menuList.about }}</p>
          <ul class="menuListCon" :class="tabTag == 1  ? 'menuListHover' : ''">
            <a href="./about.html?id=1">
              <li class="menuTab">{{ copyData.homeView.menuList.synopsis }}</li>
            </a>
            <a href="./about.html?id=2">
              <li class="menuTab">{{ copyData.homeView.menuList.develop }}</li>
            </a>
            <a href="./about.html?id=3">
              <li class="menuTab">{{ copyData.homeView.menuList.honor }}</li>
            </a>
            <a href="./about.html?id=4">
              <li class="menuTab">{{ copyData.homeView.menuList.team }}</li>
            </a>
          </ul>
        </div>
        <div class="menuList" :class="menuType == 3 ? 'menuListAct' : ''" @mouseenter="mouseOver(2)"
             @mouseleave="mouseLeave()">
          <p>{{ copyData.homeView.menuList.products }}</p>
          <ul class="menuListCon" :class="tabTag == 2 ? 'menuListTwoHover' : ''">
            <a href="./productSpring.html">
              <li class="menuTab">{{ copyData.homeView.menuList.spring }}</li>
            </a>
            <a href="./productHardware.html">
              <li class="menuTab">{{ copyData.homeView.menuList.hardware }}</li>
            </a>
          </ul>
        </div>
        <div class="menuList" :class="menuType == 4 ? 'menuListAct' : ''" @mouseenter="mouseOver(3)"
             @mouseleave="mouseLeave()">
          <p>{{ copyData.homeView.menuList.technology }}</p>
          <ul class="menuListCon" :class="tabTag == 3  ? 'menuListHover' : ''">
            <a href="./technology.html?id=1">
              <li class="menuTab">{{ copyData.homeView.menuList.echnicalAdvantages }}</li>
            </a>
            <a href="./technology.html?id=2">
              <li class="menuTab">{{ copyData.homeView.menuList.productionEquipment }}</li>
            </a>
            <a href="./technology.html?id=3">
              <li class="menuTab">{{ copyData.homeView.menuList.inspectionEquipment }}</li>
            </a>
            <a href="./technology.html?id=4">
              <li class="menuTab">{{ copyData.homeView.menuList.workshopEnvironment }}</li>
            </a>
          </ul>
        </div>
        <a href="./contact.html">
          <div class="menuList" :class="menuType == 5 ? 'menuListAct' : ''">
            <p>{{ copyData.homeView.menuList.contact }}</p>
          </div>
        </a>
      </div>
      <!-- 语言切换按钮 -->
      <a class="language" href="/en/index.html">
        <p>中/EN</p>
      </a>
    </div>
  </div>

  <!-- 屏幕尺寸为手机时显示 -->
  <div class="container" v-else>
    <!-- 头部栏 -->
    <div class="menuButton">
      <img class="menuTab" src="../../assets/images/homeView/phoneMenu.png" alt="" @click="maskTag = true">
      <a href="./index.html">
        <img src="../../assets/images/homeView/LOGO.png" alt="" class="logo">
      </a>
      <a class="language" href="/en/index.html">
        <p>中/EN</p>
      </a>
    </div>
    <!-- 遮罩层 -->
    <div class="mask" v-if="maskTag" @click="maskTag = false"></div>
    <div class="mian" v-if="maskTag">
      <ul class="menuCon">
        <a href="./index.html" class="menuList">
          <div class="menuList" :class="menuType == 1 ? 'menuListAct' : ''">{{ copyData.homeView.menuList.index }}</div>
        </a>
        <div class="menuList" :class="menuType == 2 ? 'menuListAct' : ''"
             @click="menuListTag == 1 ? menuListTag = 0 : menuListTag = 1">{{ copyData.homeView.menuList.about }}
        </div>
        <ul class="menuListCon" v-if="menuListTag == 1">
          <a href="./about.html?id=1">
            <li class="menuTab">{{ copyData.homeView.menuList.synopsis }}</li>
          </a>
          <a href="./about.html?id=2">
            <li class="menuTab">{{ copyData.homeView.menuList.develop }}</li>
          </a>
          <a href="./about.html?id=3">
            <li class="menuTab">{{ copyData.homeView.menuList.honor }}</li>
          </a>
          <a href="./about.html?id=4">
            <li class="menuTab">{{ copyData.homeView.menuList.team }}</li>
          </a>
        </ul>
        <div class="menuList" :class="menuType == 3 ? 'menuListAct' : ''"
             @click="menuListTag == 2 ? menuListTag = 0 : menuListTag = 2">{{ copyData.homeView.menuList.products }}
        </div>
        <ul class="menuListCon" v-if="menuListTag == 2">
          <a href="./productSpring.html">
            <li class="menuTab">{{ copyData.homeView.menuList.spring }}</li>
          </a>
          <a href="./productHardware.html">
            <li class="menuTab">{{ copyData.homeView.menuList.hardware }}</li>
          </a>
        </ul>
        <div class="menuList" :class="menuType == 4 ? 'menuListAct' : ''"
             @click="menuListTag == 3 ? menuListTag = 0 : menuListTag = 3">{{ copyData.homeView.menuList.technology }}
        </div>
        <ul class="menuListCon" v-if="menuListTag == 3">
          <a href="./technology.html?id=1">
            <li class="menuTab">{{ copyData.homeView.menuList.echnicalAdvantages }}</li>
          </a>
          <a href="./technology.html?id=2">
            <li class="menuTab">{{ copyData.homeView.menuList.productionEquipment }}</li>
          </a>
          <a href="./technology.html?id=3">
            <li class="menuTab">{{ copyData.homeView.menuList.inspectionEquipment }}</li>
          </a>
          <a href="./technology.html?id=4">
            <li class="menuTab">{{ copyData.homeView.menuList.workshopEnvironment }}</li>
          </a>
        </ul>
        <a class="menuList" href="./contact.html">
          <div :class="menuType == 5 ? 'menuListAct' : ''">{{ copyData.homeView.menuList.contact }}</div>
        </a>
      </ul>
    </div>
  </div>
</template>

<script>
import {defineComponent, ref, reactive} from "vue";
import {chinese} from "../../language/zh";
import {english} from "../../language/en"

export default defineComponent({
  setup() {
    // 导航栏样式变化  根据URL不同作处理
    const menuType = ref(0);
    const getHref = () => {
      const href = window.location.href
      if (href.indexOf('index') != -1) {
        menuType.value = 1
      } else if (href.indexOf('about') != -1) {
        menuType.value = 2
      } else if (href.indexOf('product') != -1) {
        menuType.value = 3
      } else if (href.indexOf('technology') != -1) {
        menuType.value = 4
      } else if (href.indexOf('contact') != -1) {
        menuType.value = 5
      }
    }

    // 语言切换  首次进入为中文，以后记住选择的状态
    const copyData = ref({})
    // 获取当前语言
    const getLanguage = () => {
      copyData.value = chinese
    }
    // 切换语言
    // const changeLanguage = () => {
    //   let type = localStorage.getItem('languageType')
    //   if(type == 'en'){
    //     localStorage.setItem('languageType', 'zh')
    //     getLanguage()
    //   } else {
    //     localStorage.setItem('languageType', 'en')
    //     getLanguage()
    //   }
    // }

    // 菜单栏展开效果
    const tabTag = ref(0)
    const mouseOver = (val) => {
      tabTag.value = val;
    };
    const mouseLeave = () => {
      tabTag.value = 0;
    };

    // 获取当前屏幕的宽度
    const windowWidth = ref(document.body.clientWidth);

    // 显示遮罩层
    const maskTag = ref(false)
    const menuListTag = ref(0)

    // 每次需执行的函数
    getLanguage()
    getHref()

    return {
      chinese,
      english,
      menuType,
      getHref,
      getLanguage,
      // changeLanguage,
      copyData,
      tabTag,
      mouseOver,
      mouseLeave,
      windowWidth,
      maskTag,
      menuListTag,
    };
  },
});
</script>

<style scoped lang="less">
// 电脑端样式
.container {
  width: 100%;
  height: 8.125rem;
  position: relative;

  .main {
    width: 75rem;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    position: relative;

    .logo {
      width: 14.125rem;
      height: auto;
      cursor: pointer;
    }

    .menuCon {
      display: flex;
      justify-content: center;
      align-items: center;

      .menuList {
        padding: 0 2rem;
        position: relative;
        font-family: SourceHanSansCN-Regular;
        font-size: 1rem;
        color: #595757;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        .menuListCon {
          width: 100%;
          height: 0rem;
          position: absolute;
          left: -2.5rem;
          top: 2.5rem;
          transition: height 0.3s;
          overflow: hidden;

          .menuTab {
            width: 100%;
            height: 2.5rem;
            background: #FFFFFF;
            font-size: .75rem;
            font-family: SourceHanSansCN-Regular;
            color: #595757;
            display: flex;
            justify-content: center;
            align-items: center;

          }

          .menuTab:hover {
            color: #FFFFFF;
            background: #0068B7;
          }
        }

        .menuListHover {
          height: 10rem;
          transition: height 0.3s;
        }

        .menuListTwoHover {
          height: 5rem;
          transition: height 0.3s;
        }
      }

      .menuListAct {
        color: #0068B7;
      }

      .menuList:hover {
        color: #0068B7;
      }
    }

    .language {
      width: 3.75rem;
      height: 1.5625rem;
      background: #0068B7;
      font-size: 1rem;
      color: #FFFFFF;
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 1.5625rem;
      border-radius: .7813rem;
      cursor: pointer;
    }
  }
}


html[lang="en"] {
  .container {
    .main {
      .menuCon {
        .menuList {
          .menuListCon {
            .menuTab {
              font-size: .625rem;
            }
          }
        }
      }
    }
  }
}

// 手机端样式
@media screen and (max-width: 56.25rem) {
  .container {
    width: 100vw;
    height: auto;
    position: relative;

    .menuButton {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding: 4vw 4vw 0;

      .menuTab {
        width: 8vw;
        height: auto;
      }

      .logo {
        height: 8vw;
        width: auto;
      }

      .language {
        width: 12vw;
        height: 6vw;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #0068B7;
        font-size: 3.2vw;
        color: #FFFFFF;
        border-radius: 3vw;
        line-height: 6vw;
      }
    }

    .mask {
      width: 100vw;
      height: 100vh;
      background: hsla(0, 0%, 0%, 0.5);
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1000;
    }

    .mian {
      width: 60vw;
      height: 100vh;
      background: #FFFFFF;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1001;

      .menuCon {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
        padding-top: 5vw;

        .menuList {
          width: 100%;
          height: 14vw;
          font-size: 4.3vw;
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }

        .menuListAct {
          color: #0068B7;
        }

        .menuListCon {
          width: 100%;
          font-size: 3.7vw;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;

          .menuTab {
            height: 7vw;
            display: flex;
            justify-content: flex-start;
            align-items: center;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Header.vue?50dd2268